import { Layer } from '../layer';
import { CommonEnums } from '../../common.enums';


export class LayersUtil {
    private static instance: LayersUtil;

    static getInstance() {
        if (!LayersUtil.instance) {
            LayersUtil.instance = new LayersUtil();
        }

        return LayersUtil.instance;
    }

    /**
    * LayersUtil is a singleton class, so use LayersUtil.getInstance() method instead of creating new LayersUtil().
    */
    private constructor() {

    }
    
    getNms(layers: Array<Layer>): Array<string> {
        let nms: Array<string> = new Array<string>();

        for (var i: number = 0; i < layers.length; i++) {
            nms.push(layers[i].nm);
        }

        return nms;
    }

    getUppercaseNms(layers: Array<Layer>): Array<string> {
        let nms: Array<string> = new Array<string>();

        for (var i: number = 0; i < layers.length; i++) {
            nms.push(layers[i].nm.toUpperCase());
        }

        return nms;
    }

    getPrimaryKey(layer: Layer): string {
        return layer.layer_Id.toString();
    }

    copy(layersTmp: Array<Layer>): Array<Layer> {
        let layers: Array<Layer> = new Array<Layer>();

        for (var i: number = 0; i < layersTmp.length; i++) {
            let layer: Layer = layersTmp[i] as Layer;
            layers.push(layer.copy())
        }

        return layers;
    }

    copyFrom(layers: Array<Layer>, layersTmp: Array<Layer>): void {
        let layersMap: Map<string, Layer> = new Map<string, Layer>();
        for (let i: number = 0; i < layers.length; i++) {
            let layer: Layer = layers[i] as Layer;
            layersMap.set(this.getPrimaryKey(layer), layer);
        }

        layers.splice(0, layers.length);

        for (let i: number = 0; i < layersTmp.length; i++) {
            let layerTmp: Layer = layersTmp[i] as Layer;

            let layer: Layer = layersMap.get(this.getPrimaryKey(layerTmp));
            if (layer) {
                layer.copyFrom(layerTmp);
            } else {
                layer = Layer.parse(layerTmp);
            }

            layers.push(layer);
        }
    }

    compare(layers: Array<Layer>, layersTmp: Array<Layer>) {
        if (layers.length != layersTmp.length)
            return 'layers length mismatch.';

        for (var i: number = 0; i < layers.length; i++) {
            let layer: Layer = layers[i] as Layer;
            let layerTmp: Layer = layersTmp[i] as Layer;

            let diffString: string = layer.compare(layerTmp);
            if (diffString != CommonEnums.defaults.STRING_EMPTY)
                return diffString;
        }

        return '';
    }

    toString(layers: Array<Layer>) {
        let str: string = '';

        str += 'layer length: ' + layers.length + ' ';

        for (var i: number = 0; i < layers.length; i++) {
            let layer: Layer = layers[i] as Layer;
            str += layer.toString();
        }

        return str;
    }
}